import { render, staticRenderFns } from "./DTabbar.vue?vue&type=template&id=d2d94676&scoped=true&"
import script from "./DTabbar.vue?vue&type=script&lang=js&"
export * from "./DTabbar.vue?vue&type=script&lang=js&"
import style0 from "./DTabbar.vue?vue&type=style&index=0&id=d2d94676&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2d94676",
  null
  
)

export default component.exports